<ng-container *t="let t" [formGroup]="contactForm">
    <h3 class="form-header" mat-tialog-title *ngIf="data" i18n="@@e5453b5be1beddd6eeed156587b64c9cf77ddf86"
        t="e5453b5be1beddd6eeed156587b64c9cf77ddf86">Edit Contact</h3>
    <h3 class="form-header" mat-tialog-title *ngIf="!data" i18n="@@865ab741dc958e81f022357da2f87036b5ab0409"
        t="865ab741dc958e81f022357da2f87036b5ab0409">New Contact</h3>

    <div style="max-height: 750px; overflow-y: auto;">
        <div class="grid">
            <div class="row">
                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@c83b838d845690bcb897f775f53b5316535306dc"
                            t="c83b838d845690bcb897f775f53b5316535306dc">First Name</tsl-label>
                        <input required tslInput fullWidth type="text" formControlName="FirstName" name="txtFirstName"
                            maxlength="30" tPlaceholder="c83b838d845690bcb897f775f53b5316535306dc"
                            i18n-placeholder="@@c83b838d845690bcb897f775f53b5316535306dc" placeholder="First Name" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('FirstName').value?.length || 0
                            }}
                            / 30
                        </mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.FirstName.errors &&
                                (ContactformControls.FirstName.dirty || ContactformControls.FirstName.touched) &&
                                ContactformControls.FirstName.errors.whitespace
                            ">
                            <span i18n="@@14e192cb676257db8fed3dad864f5e5f8a17e119"
                                t="14e192cb676257db8fed3dad864f5e5f8a17e119">First Name is Required
                            </span>
                        </tsl-error>
                        <tsl-error *ngIf="
                                ContactformControls.FirstName.errors &&
                                !ContactformControls.FirstName.errors.required &&
                                ContactformControls.FirstName.errors.pattern
                            ">
                            <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54"
                                t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters
                                allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@166b2cc65003221ff5f3ec05d5baca41e6821396"
                            t="166b2cc65003221ff5f3ec05d5baca41e6821396">Last Name</tsl-label>
                        <input required tslInput fullWidth type="text" formControlName="LastName" name="txtLastName"
                            maxlength="30" tPlaceholder="166b2cc65003221ff5f3ec05d5baca41e6821396"
                            i18n-placeholder="@@166b2cc65003221ff5f3ec05d5baca41e6821396" placeholder="Last Name" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('LastName').value?.length || 0
                            }} /
                            30
                        </mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.LastName.errors &&
                                (ContactformControls.LastName.dirty || ContactformControls.LastName.touched) &&
                                ContactformControls.LastName.errors.whitespace
                            ">
                            <span i18n="@@3da6a76bc3eaba500cadef813d5bb7fa09e7e9eb"
                                t="3da6a76bc3eaba500cadef813d5bb7fa09e7e9eb">Last Name is Required
                            </span>
                        </tsl-error>
                        <tsl-error *ngIf="
                                ContactformControls.LastName.errors &&
                                !ContactformControls.LastName.errors.required &&
                                ContactformControls.LastName.errors.pattern
                            ">
                            <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54"
                                t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters
                                allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@244aae9346da82b0922506c2d2581373a15641cc"
                            t="244aae9346da82b0922506c2d2581373a15641cc">Email</tsl-label>
                        <!-- todo ttp -->
                        <input required tslInput fullWidth type="email" (blur)="setDomainFields()"
                            tPlaceholder="244aae9346da82b0922506c2d2581373a15641cc"
                            i18n-placeholder="@@244aae9346da82b0922506c2d2581373a15641cc" placeholder="Email"
                            formControlName="Email" name="txtEmail" maxlength="256" />
                        <tsl-icon *ngIf="showEmailInfo" tslTooltip="{{ EmailInfo }}">info</tsl-icon>
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Email').value?.length || 0 }}
                            /
                            256</mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.Email.errors &&
                                ContactformControls.Email.errors.required &&
                                (ContactformControls.Email.dirty || ContactformControls.Email.touched)
                            ">
                            <span i18n="@@d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71"
                                t="d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71">Email is Required
                            </span>
                        </tsl-error>
                        <tsl-error *ngIf="ContactformControls.Email.errors && ContactformControls.Email.errors.email">
                            <span i18n="@@e5d28518a74d03d6ba089a7046ea9e38fbc026e4"
                                t="e5d28518a74d03d6ba089a7046ea9e38fbc026e4">Enter a valid email
                            </span>
                        </tsl-error>
                        <tsl-error
                            *ngIf="ContactformControls.Email.errors && ContactformControls.Email.errors.invalidDomain">
                            <span i18n="@@unapproveddomainerror" t="unapproveddomainerror">Please use an email that
                                includes an approved domain on file with Tesla.
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@917fe77920bc5c5f63200a05b50ac35b1d0e9156"
                            t="917fe77920bc5c5f63200a05b50ac35b1d0e9156">Email Communication Language_form</tsl-label>
                        <!-- todo ttp -->
                        <tsl-select tPlaceholder="917fe77920bc5c5f63200a05b50ac35b1d0e9156"
                            i18n-placeholder="@@917fe77920bc5c5f63200a05b50ac35b1d0e9156"
                            placeholder="Email Communication Language" formControlName="LanguageCode"
                            name="LanguageCode">
                            <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                                t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                            <tsl-option *ngFor="let language of languages" [value]="language.id">{{
                                translate.get(language.name)
                                }}</tsl-option>
                        </tsl-select>
                        <tsl-error *ngIf="
                                ContactformControls.LanguageCode.errors &&
                                (ContactformControls.LanguageCode.dirty || ContactformControls.LanguageCode.touched)
                            ">
                            <span i18n="@@b83141f14cc364caf1fe6a920dc936209d1c3958"
                                t="b83141f14cc364caf1fe6a920dc936209d1c3958">Language is Required
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                            t="20d9489fdbfc121f7c504271b36691515d02f632">Job Title</tsl-label>
                        <!-- todo ttp -->
                        <input required tslInput fullWidth type="text"
                            tPlaceholder="20d9489fdbfc121f7c504271b36691515d02f632"
                            i18n-placeholder="@@20d9489fdbfc121f7c504271b36691515d02f632" placeholder="Job Title"
                            formControlName="JobTitle" name="txtJobTitle" maxlength="100" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('JobTitle').value?.length || 0
                            }} /
                            100
                        </mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.JobTitle.errors &&
                                (ContactformControls.JobTitle.dirty || ContactformControls.JobTitle.touched) &&
                                ContactformControls.JobTitle.errors.whitespace
                            ">
                            <span i18n="@@cd38fe5de7b920fd0f7059e1b3148bb6f3609b99"
                                t="cd38fe5de7b920fd0f7059e1b3148bb6f3609b99">Job Title is Required
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@7ef67f76ab81c082a91782412af3639cca2126de"
                            t="7ef67f76ab81c082a91782412af3639cca2126de">Mobile</tsl-label>
                        <!-- todo ttp -->
                        <input tslInput fullWidth type="text" tPlaceholder="7ef67f76ab81c082a91782412af3639cca2126de"
                            i18n-placeholder="@@7ef67f76ab81c082a91782412af3639cca2126de" placeholder="Mobile"
                            formControlName="Mobile" name="txtMobile" maxlength="30" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Mobile').value?.length || 0 }}
                            /
                            30</mat-hint>
                        <tsl-error
                            *ngIf="ContactformControls.Mobile.errors && ContactformControls.Mobile.errors.pattern">
                            <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86"
                                t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and #
                                ( )
                                + - characters allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@6934d8edd276d59e050006fe91b695ebad0218f8"
                            t="6934d8edd276d59e050006fe91b695ebad0218f8">Phone</tsl-label>
                        <!-- todo ttp -->
                        <input required tslInput fullWidth type="text"
                            tPlaceholder="6934d8edd276d59e050006fe91b695ebad0218f8"
                            i18n-placeholder="@@6934d8edd276d59e050006fe91b695ebad0218f8" placeholder="Phone"
                            formControlName="Phone" name="txtPhone" maxlength="30" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Phone').value?.length || 0 }}
                            /
                            30</mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.Phone.errors &&
                                (ContactformControls.Phone.dirty || ContactformControls.Phone.touched) &&
                                ContactformControls.Phone.errors.whitespace
                            ">
                            <span i18n="@@060c3b509b8af218451c50408ce9ff39b779ba10"
                                t="060c3b509b8af218451c50408ce9ff39b779ba10">Phone is Required
                            </span>
                        </tsl-error>
                        <tsl-error *ngIf="
                                ContactformControls.Phone.errors &&
                                !ContactformControls.Phone.errors.required &&
                                ContactformControls.Phone.errors.pattern
                            ">
                            <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86"
                                t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and #
                                ( )
                                + - characters allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@c51dd3c995cd973b8678838ac584270932b410c3"
                            t="c51dd3c995cd973b8678838ac584270932b410c3">Fax</tsl-label>
                        <!-- todo ttp -->
                        <input tslInput fullWidth type="text" tPlaceholder="c51dd3c995cd973b8678838ac584270932b410c3"
                            i18n-placeholder="@@c51dd3c995cd973b8678838ac584270932b410c3" placeholder="Fax"
                            formControlName="Fax" name="txtFax" maxlength="30" />
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Fax').value?.length || 0 }} /
                            30</mat-hint>
                        <tsl-error *ngIf="ContactformControls.Fax.errors && ContactformControls.Fax.errors.pattern">
                            <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86"
                                t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and #
                                ( )
                                + - characters allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="100">
                    <tsl-checkbox formControlName="SkipResidenceCountry">
                        <span class="checkbox-text" i18n="@@DoNotWishToProvideResidenceCountry"
                            t="DoNotWishToProvideResidenceCountry">I do not wish to provide the country of residence for
                            this contact.</span>
                    </tsl-checkbox>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@CountryOfResidence" t="CountryOfResidence">Country of Residence</tsl-label>
                        <tsl-select shape="round" placeholder="Country of Residence" tPlaceholder="CountryOfResidence"
                            i18n-placeholder="@@CountryOfResidence" formControlName="ResidenceCountry">
                            <tsl-option>Select</tsl-option>
                            <tsl-option *ngFor="let country of countries$ | async | sortBy: 'asc': 'Name'"
                                [value]="country.abbreviation">
                                {{ translate.get(country.name) }}
                            </tsl-option>
                        </tsl-select>
                        <tsl-error
                            *ngIf="ContactformControls.ResidenceCountry.errors && (ContactformControls.ResidenceCountry.dirty || ContactformControls.ResidenceCountry.touched)">
                            <span i18n="@@CountryOfResidenceIsRequired" t="CountryOfResidenceIsRequired">Country of
                                residence is required</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@4b8f49e1a68db0233c23ba28ff45a328f53aebfb"
                            t="4b8f49e1a68db0233c23ba28ff45a328f53aebfb">Contact Purpose</tsl-label>
                        <!-- todo ttp -->
                        <tsl-select multiple tPlaceholder="4b8f49e1a68db0233c23ba28ff45a328f53aebfb"
                            i18n-placeholder="@@4b8f49e1a68db0233c23ba28ff45a328f53aebfb" placeholder="Contact Purpose"
                            formControlName="Types" name="Types">
                            <tsl-optgroup *ngFor="let group of contactTypeGroups" [label]="group.Name"
                                [disabled]="group.disabled">
                                <tsl-option *ngFor="let type of group.Types" [value]="type.id"
                                    [disabled]="disableContactType(type)" withArrow="true" tslTooltipPosition="Right"
                                    [tslTooltip]="getCategoryTooltip(type.id)">
                                    {{ translate.get(type.id) }}</tsl-option>
                            </tsl-optgroup>
                        </tsl-select>
                        <tsl-error *ngIf="
                                ContactformControls.Types.errors &&
                                (ContactformControls.Types.dirty || ContactformControls.Types.touched)
                            ">
                            <span i18n="@@bac382c02b9ae2cc9877e1a1171f8ae901f40b74"
                                t="bac382c02b9ae2cc9877e1a1171f8ae901f40b74">Contact Purpose is Required
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>
                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@c5bb9f8936cb33db2ca351a1b87a984fdf11917c"
                            t="c5bb9f8936cb33db2ca351a1b87a984fdf11917c">Comments</tsl-label>
                        <!-- todo ttp -->
                        <textarea tslInput fullWidth type="text" tPlaceholder="Comments" i18n-placeholder="@@Comments"
                            placeholder="Comments" formControlName="Comment" name="txtComment"
                            maxlength="100"></textarea>
                        <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Comment').value?.length || 0
                            }} /
                            100
                        </mat-hint>
                        <tsl-error *ngIf="
                                ContactformControls.Comment.errors &&
                                !ContactformControls.Comment.errors.required &&
                                ContactformControls.Comment.errors.pattern
                            ">
                            <span i18n="@@2258782926161870916" t="2258782926161870916">Only alphanumeric, underscore,
                                space,
                                hyphen, !, $, % characters allowed</span>
                        </tsl-error>
                    </tsl-form-field>
                </div>
                <div fxFlex="90" *ngIf="showITcontactWarning">
                    <p class="checkbox-label" i18n="@@itcontactwarning" t="itcontactwarning">
                        Please ensure the assigned IT Contact for your business or organization is indeed a
                        representative
                        of your IT department in case Tesla needs to contact them for IT-related matters.
                    </p>
                    <tsl-checkbox name="itchecking" formControlName="ITchecking" (change)="iTCheckBox($event)">
                        <span class="checkbox-text" i18n="@@itcontactwarningiconfirm" t="itcontactwarningiconfirm">I
                            Confirm.</span>
                    </tsl-checkbox>
                    <tsl-error *ngIf="showITcontactWarning">
                        <span class="checkbox-error"
                            *ngIf="showITcontactWarning && contactForm.get('ITchecking').value!=true"
                            i18n="@@itcontactwarningcheckboxisrequierd" t="itcontactwarningcheckboxisrequierd">Checkbox
                            is
                            required </span>
                    </tsl-error>
                </div>
                <div *ngIf="showDomainDiffSection" fxFlex="100">
                    <div fxFlex="46" style="margin-right: 65px; margin-left: 10px;">
                        <tsl-label i18n="@@domaindifferenceQuestion" t="domaindifferenceQuestion"
                            [ngClass]="{'field-error': ContactformControls.HasValidDomain?.touched && !ContactformControls.HasValidDomain?.valid}">You
                            are creating a contact who has an email domain not on file with Tesla. Does this contact
                            have an
                            email address that includes an approved company domain?</tsl-label>
                        <!-- todo ttp -->
                        <tsl-radio-group class="radio-group-example" formControlName="HasValidDomain">
                            <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                            <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                        </tsl-radio-group>
                        <tsl-error style="font-size: 12px;"
                            *ngIf="ContactformControls.HasValidDomain?.touched && !ContactformControls.HasValidDomain?.valid">
                            <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                        </tsl-error>
                    </div>

                    <div fxFlex="50" *ngIf="ContactformControls?.HasValidDomain?.value == 'No'">
                        <tsl-label i18n="@@AddEmailToValidDomainList" t="AddEmailToValidDomainList"
                            [ngClass]="{'field-error': ContactformControls.AddToValidDomain?.touched && !ContactformControls.AddToValidDomain?.valid}">Should
                            this contact domain be added as an approved domain on file with Tesla?</tsl-label>
                        <!-- todo ttp -->
                        <tsl-radio-group class="radio-group-example" formControlName="AddToValidDomain">
                            <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                            <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                        </tsl-radio-group>
                        <tsl-error style="font-size: 12px;"
                            *ngIf="ContactformControls.AddToValidDomain?.touched && !ContactformControls.AddToValidDomain?.valid">
                            <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                        </tsl-error>
                    </div>
                </div>
                <div fxFlex="100" *ngIf="ContactformControls?.AddToValidDomain?.value == 'No'"
                    style="margin-top: 25px;">
                    <div fxFlex="50">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@newdomainReason" t="newdomainReason">Please provide further context on
                                this domain difference.</tsl-label>
                            <tsl-select shape="round"
                                placeholder="Please provide further context on this contact submission and domain difference."
                                tPlaceholder="newdomainReason" i18n-placeholder="@@newdomainReason"
                                formControlName="Reason">
                                <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                                    t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                                <tsl-option *ngFor="let code of contactReasons$ | async" [value]="code">
                                    {{ translate.get(code) }}
                                </tsl-option>
                            </tsl-select>
                            <tsl-error
                                *ngIf="ContactformControls.Reason.errors && (ContactformControls.Reason.dirty || ContactformControls.Reason.touched)">
                                <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                    t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>
                    <div fxFlex="50" *ngIf="ContactformControls?.Reason?.value == 'Other'">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@nameChangeCommentLabel" t="nameChangeCommentLabel">Please provide other
                                reasons:</tsl-label>
                            <!-- todo ttp -->
                            <input tslInput fullWidth type="text" tPlaceholder="nameChangeCommentLabel"
                                i18n-placeholder="@@nameChangeCommentLabel" placeholder="Please provide other reasons:"
                                formControlName="AdditionalReason" name="txtAdditionalReason" maxlength="100" />
                            <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Fax').value?.length || 0
                                }} /
                                100</mat-hint>
                            <tsl-error
                                *ngIf="ContactformControls.AdditionalReason.errors && (ContactformControls.AdditionalReason.dirty || ContactformControls.AdditionalReason.touched)">
                                <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                    t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>
                </div>
                <div fxFlex="100" *ngIf="ContactformControls?.AddToValidDomain?.value == 'No'"
                    style="margin-top: 25px;">
                    <div fxFlex="100">
                        <tsl-form-field fxFlex="95">
                            <tsl-label i18n="@@newdomainComment" t="newdomainComment">Please outline these services and
                                how they connect to the business interaction with Tesla in the comments
                                below.</tsl-label>
                            <!-- todo ttp -->
                            <textarea tslInput fullWidth type="text" tPlaceholder="newdomainComment"
                                i18n-placeholder="@@newdomainComment"
                                placeholder="Please provide further details on the connection between the requested domain and your organization."
                                formControlName="DomainComment" name="txtDomainComment" maxlength="250" minlength="50"
                                style="min-height: 100px;"></textarea>
                            <mat-hint align="end" class="max-length-hint">{{
                                contactForm.get('DomainComment').value?.length
                                || 0 }} / 250
                            </mat-hint>
                            <tsl-error *ngIf="
                                    ContactformControls.DomainComment.errors">
                                <span i18n="@@PleaseAtAeastEnter50Characters" t="PleaseAtAeastEnter50Characters">Please
                                    at least enter 50 characters</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>
                </div>
                <div fxFlex="100" *ngIf="ContactformControls?.AddToValidDomain?.value == 'No'"
                    style="margin-bottom: 25px;">
                    <div fxFlex="46" style="margin-right: 65px; margin-left: 10px;">
                        <tsl-label i18n="@@domainHasWebsite" t="domainHasWebsite">Is there a website linked to the
                            domain that outlines the domain difference
                            or how it connects to the Supplier organization?</tsl-label>
                        <!-- todo ttp -->
                        <tsl-radio-group class="radio-group-example" formControlName="HasWebsite">
                            <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                            <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                        </tsl-radio-group>
                        <tsl-error style="font-size: 12px;"
                            *ngIf="ContactformControls.HasWebsite?.touched && !ContactformControls.HasWebsite?.valid">
                            <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                        </tsl-error>
                    </div>
                    <div fxFlex="50" *ngIf="ContactformControls?.HasWebsite?.value == 'Yes'">
                        <tsl-form-field fxFlex="90">
                            <tsl-label i18n="@@domainWebsite" t="domainWebsite">Please provide the website
                                link:</tsl-label>
                            <!-- todo ttp -->
                            <input tslInput fullWidth type="text" tPlaceholder="domainWebsite"
                                i18n-placeholder="@@domainWebsite" placeholder="Please provide the website link:"
                                formControlName="Website" name="txtWebsite" maxlength="250" />
                            <mat-hint align="end" class="max-length-hint">{{ contactForm.get('Website').value?.length ||
                                0
                                }} / 250</mat-hint>
                            <tsl-error
                                *ngIf="ContactformControls.Website.errors && (ContactformControls.Website.dirty || ContactformControls.Website.touched)">
                                <span i18n="@@434f8f6235a970107568236f8a35a307dddd13e0"
                                    t="434f8f6235a970107568236f8a35a307dddd13e0">This field is required.</span>
                            </tsl-error>
                        </tsl-form-field>
                    </div>
                </div>
                <div fxFlex="100" *ngIf="ContactformControls?.HasValidDomain?.value == 'Yes'">
                    <tsl-label style="padding-left: 30%;"><tsl-icon style="color: #cbcb37;"
                            class="warning">warning</tsl-icon>
                        <span i18n="@@addApprovedDomainEmail" t="addApprovedDomainEmail">Please update the email address
                            with an approved company domain in order to
                            submit this contact request.</span> </tsl-label>
                </div>
            </div>
        </div>
        <div class="grid" *ngIf="showDocument" style="margin-bottom: 25px;">
            <div class="row">
                <div fxFlex="10">
                    <tsl-label class="documents"><span i18n="@@Documents" t="Documents">Documents</span>
                        <!-- todo ttp -->
                        <tsl-icon
                            tooltip="Please download the New Supplier Primary Contact form located in the below Guidelines link. Ensure this form is completed for your Primary Contact change submission."
                            i18n-tooltip="@@6650292056537691915" #infoIcon
                            tslTooltip="{{ t('6650292056537691915', infoIcon) }}">
                            info</tsl-icon>
                    </tsl-label>
                </div>
                <div fxFlex="90">
                    <!-- todo ttp -->
                    <button i18n-matTooltip matTooltip="Add Document" (click)="onDocumentAdding()" tsl-button
                        size="small" color="black" outline i18n="@@c8ddebeb98c68bca5c3f0463f012199053ab47b1"
                        t="c8ddebeb98c68bca5c3f0463f012199053ab47b1">
                        Add Document
                    </button>
                </div>
            </div>
            <div class="row" *ngIf="isDocumentAdding">
                <div fxFlex="95">
                    <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" #fileDrop [accept]="getAcceptedFormat" (fileChange)="onFileAdd($event, 'PCF')">
                    </tsl-file-drop>
                    <mat-hint>
                        <a target="_blank" [href]="guideLinesUrl" i18n="@@a6a0a4da3e30cfc3f654b9d1d89d33d00f192841"
                            t="a6a0a4da3e30cfc3f654b9d1d89d33d00f192841">Guidelines Page</a>
                    </mat-hint>
                </div>
            </div>
        </div>
        <div *ngIf="showCorrDocument">
            <div class="row">
                <div fxFlex="100">
                    <tsl-label><span i18n="@@corrdocumentlabel" t="corrdocumentlabel">Optional - Please attach any
                            supporting correspondence related to the domain difference</span>
                    </tsl-label>
                </div>
            </div>
            <div class="row">
                <div fxFlex="95">
                    <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" #fileDrop [accept]="getAcceptedFormat" (fileChange)="onFileAdd($event, 'CORR-ED')">
                    </tsl-file-drop>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="documents && documents.length > 0">
            <div class="row" formArrayName="documents" *ngFor="let doc of documents['controls']; let i = index">
                <div class="row" [formGroupName]="i">
                    <div fxFlex="50">
                        <tsl-label class="label">{{ doc.get('fileName').value }}</tsl-label>
                        <button *ngIf="!doc.get('documentId').value" (click)="removeFile(i)" tsl-icon-button>
                            <tsl-icon>delete</tsl-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions align="end" class="right">
        <button tsl-button size="small" color="blue" filled (click)="save()" i18n="@@Save" t="Save">Save</button>
        <button tsl-button size="small" color="black" outline (click)="onNoClick()" i18n="@@Close"
            t="Close">Close</button>
    </div>
</ng-container>